/**
 * The whole form, from the compiled product.
 *
 * This component has no idea what a product is. It reads sections, draws them,
 * and hands the answers back - which is the claim the platform makes, made
 * literal: a new product changes what appears here without changing this file.
 */
import type { AnswerDocument, CompiledProduct, ValidationIssue } from "@dp/shared";
import { Section, type Problems } from "./Section.tsx";

export function Form({
  product, answers, readOnly, issues, onChange,
}: {
  product: CompiledProduct;
  answers: AnswerDocument;
  readOnly: boolean;
  issues: ValidationIssue[];
  onChange: (next: AnswerDocument) => void;
}) {
  const problems: Problems = { byPath: new Map() };
  for (const issue of issues) {
    const existing = problems.byPath.get(issue.path) ?? [];
    existing.push(issue.message);
    problems.byPath.set(issue.path, existing);
  }

  return (
    <div className="stack">
      {product.sections.map((section) => (
        <Section
          key={section.key}
          section={section}
          answers={answers}
          readOnly={readOnly}
          problems={problems}
          onChange={onChange}
        />
      ))}
    </div>
  );
}
